"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImpactChainMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const locales_1 = require("../../internationalization/features/locales");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const MOCK_SHARING_LINK = "https://www.zeffy.com/en-US/donation-form/my-campaign?impact_chain_source=sammy@zeffy.com";
const buildImpactChainMockData = ({ orgName, color, isDarkMode, firstName = "Sammy", campaignName = "Spring Fundraiser", paymentAmount = "$50", donorFullName = "Alex Johnson", sharingLinkUrl = MOCK_SHARING_LINK, locale = "en", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    const emailLocale = (0, locales_1.resolveUntranslatedSpanishEmailLocale)(locale.toUpperCase()).toLowerCase();
    const labels = (0, email_templates_1.getEmailLabels)(emailLocale);
    const resolvedOrgName = orgName || "Bright Futures Foundation";
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang: emailLocale,
        subject: labels.impactChainSubject
            .replace("{donorFullName}", donorFullName)
            .replace("{paymentAmount}", paymentAmount)
            .replace("{orgName}", resolvedOrgName),
        orgName: resolvedOrgName,
        firstName,
        campaignName,
        paymentAmount,
        donorFullName,
        sharingLinkUrl,
        message: null,
    };
};
exports.buildImpactChainMockData = buildImpactChainMockData;
